import { render, staticRenderFns } from "./MeusFavoritos.vue?vue&type=template&id=655d04a4&scoped=true&"
import script from "./MeusFavoritos.vue?vue&type=script&lang=js&"
export * from "./MeusFavoritos.vue?vue&type=script&lang=js&"
import style0 from "./MeusFavoritos.vue?vue&type=style&index=0&id=655d04a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655d04a4",
  null
  
)

export default component.exports